export default __webpack_public_path__ + "static/media/notification&sos-seen.e3b9755b.svg";